import React, { Fragment, useState, useEffect } from 'react';
import validator from 'validator';
import { useSelector, useDispatch } from 'react-redux';

import { DialogActions, DialogTitle, Dialog } from '@mui/material';
import { Box } from '@mui/material';
import {
  Typography,
  colors,
  Input,
  IconGraphy,
  Button,
  Radio,
  DatePickerInput,
} from '@leapeasy/ui-kit';
import { getAge } from '../../components/helpers';
import OtpPage from '../Otp';
import { setDataAction } from 'redux/actions/shortFormActions';
import { sendEmailVerificationAction } from 'redux/actions/emailActions';
import { CustomInputWrapper } from 'components/CustomWrapper';
import { validationMessages } from 'utils/validationMessages';

const Form1 = (props) => {
  const { handleNext, handleBack } = props;
  const dispatch = useDispatch();
  const formData = useSelector((state) => state.shortFormData);

  const [data, setFormData] = useState({
    fname: null,
    lname: null,
    phone: null,
    email: null,
    isStudent: null,
    birthDate: null,
  });

  const [valid, setValid] = useState({
    fname: true,
    lname: true,
    phone: true,
    email: true,
    birthDate: true,
  });
  const [openAlert, setOpenAlert] = useState(false);
  const [shouldShowEmailVerification, setShowEmailVerification] = useState(false);

  useEffect(() => {
    if (formData.data.fname) {
      setFormData({
        fname: formData.data.fname,
        lname: formData.data.lname,
        phone: formData.data.phone,
        email: formData.data.email,
        birthDate: formData.data.birthDate,
        isStudent: formData.data.isStudent,
      });
    }
  }, [formData]);

  const handleChange = (e, label) => {
    let value = e.target.value;
    value = value === 'true' ? true : value === 'false' ? false : value;

    setFormData({ ...data, [label]: value });
    if (label === 'email') {
      setValid({ ...valid, email: validator.isEmail(value) });
    }
    if (label === 'phone') {
      setValid({
        ...valid,
        phone: value.length === 14 || (value.length === 15 && value[0] === '+') ? true : false,
      });
    }

    if (label === 'birthDate') {
      const age = getAge(value);
      if (age < 18) {
        setOpenAlert('age');
        setValid({ ...valid, [label]: false });
      } else {
        setValid({ ...valid, [label]: true });
      }
    }
  };

  const handleNextButton = () => {
    dispatch(
      setDataAction({
        ...formData.data,
        fname: data.fname,
        lname: data.lname,
        phone: data.phone,
        email: data.email,
        birthDate: data.birthDate,
        age: getAge(data.birthDate),
        isStudent: data.isStudent,
      }),
    );

    dispatch(sendEmailVerificationAction({ email: data.email, fname: data.fname }));
    setShowEmailVerification(true);
  };

  if (shouldShowEmailVerification) {
    return (
      <OtpPage
        handleBack={() => setShowEmailVerification(false)}
        handleNext={handleNext}
        target={{
          email: data.email,
          fname: data.fname,
        }}
      />
    );
  }

  return (
    <Fragment>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <CustomInputWrapper>
        <Input
          value={data.fname}
          onChange={(e) => handleChange(e, 'fname')}
          label="First Name"
          helperMessage={!valid.fname && data.fname && validationMessages.firstName}
          type="text"
          errorType={!valid.fname && data.fname ? 'error' : 'none'}
          icon={<IconGraphy icon="Users.User" />}
          minWidth="100%"
          size="medium"
          showCopy={false}
          fullWidth
        /></CustomInputWrapper>
<CustomInputWrapper>
        <Input
          value={data.lname}
          onChange={(e) => handleChange(e, 'lname')}
          label="Last Name"
          helperMessage={!valid.lname && data.lname && validationMessages.lastName}
          type="text"
          errorType={!valid.lname && data.lname ? 'error' : 'none'}
          icon={<IconGraphy icon="Users.User" />}
          minWidth="100%"
          size="medium"
          showCopy={false}
          fullWidth
        /></CustomInputWrapper>
<CustomInputWrapper>
        <Input
          value={data.email}
          onChange={(e) => handleChange(e, 'email')}
          label="Contact Email"
          helperMessage={!valid.email && data.email && validationMessages.email}
          type="email"
          errorType={!valid.email && data.email ? 'error' : 'none'}
          icon={<IconGraphy icon="Notifications.Email" />}
          minWidth="100%"
          size="medium"
          showCopy={false}
          fullWidth
        /></CustomInputWrapper>
<CustomInputWrapper>
        <Input
          value={data.phone || ''}
          onChange={(e) => handleChange(e, 'phone')}
          label="Contact Phone Number"
          helperMessage={!valid.phone && data.phone && validationMessages.phone}
          type="tel"
          errorType={!valid.phone && data.phone ? 'error' : 'none'}
          minWidth="100%"
          size="medium"
          phoneCountry="US"
          showCopy={false}
          fullWidth
        /></CustomInputWrapper>
        <Box
          className="rg-datepicker"
          sx={{ position: 'relative', zIndex: 10, overflow: 'visible', width: '100%' }}
        >
          <DatePickerInput
            label="Date of Birth"
            value={data.birthDate || ''}
            onChange={(e) => handleChange(e, 'birthDate')}
            helperMessage={
              !valid.birthDate && data.birthDate && validationMessages.birthDateUnder18
            }
            errorType={!valid.birthDate && data.birthDate ? 'error' : 'none'}
            minWidth="100%"
            size="medium"
            maxDate={new Date().toISOString().slice(0, 10)}
            fullWidth
            showActionButtons
          />
        </Box>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="body1" style={{ color: colors.purple[900], fontWeight: '400' }}>
          Are you a Full-Time Student?
        </Typography>

        <Box display="flex" alignItems="flex-start" sx={{ gap: '24px', marginTop: 2 }}>
          <Radio
            label="Yes"
            value={data.isStudent === true}
            onChange={(_) => handleChange({ target: { value: 'true' } }, 'isStudent')}
          />
          <Radio
            label="No"
            value={data.isStudent === false}
            onChange={(_) => handleChange({ target: { value: 'false' } }, 'isStudent')}
          />
        </Box>
      </Box>

      <Box
        sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', mt: 4, gap: '16px' }}
      >
        <Button
          variant="primary"
          size="medium"
          onClick={handleNextButton}
          disabled={
            !(
              data.fname &&
              data.lname &&
              data.phone &&
              data.email &&
              data.birthDate &&
              data.isStudent != null &&
              valid.fname &&
              valid.lname &&
              valid.phone &&
              valid.email &&
              valid.birthDate
            )
          }
          style={{ flexGrow: 1 }}
        >
          Next
        </Button>
      </Box>

      <Dialog onClose={() => setOpenAlert(null)} open={!!openAlert}>
        <DialogTitle>
          <Typography sx={{ color: '#e71212' }} variant="h5">
            Must be at least 18 years old to apply
          </Typography>
        </DialogTitle>
        <DialogActions>
          <Button variant="primary" onClick={() => setOpenAlert(false)}>
            I Understand
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default Form1;
